import { render, staticRenderFns } from "./ProductSalesOrderCreate.vue?vue&type=template&id=f4f83f92&"
import script from "./ProductSalesOrderCreate.vue?vue&type=script&lang=js&"
export * from "./ProductSalesOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports